import { render, staticRenderFns } from "./platformWithdrawal.vue?vue&type=template&id=0a658149&scoped=true"
import script from "./platformWithdrawal.vue?vue&type=script&lang=js"
export * from "./platformWithdrawal.vue?vue&type=script&lang=js"
import style0 from "./platformWithdrawal.vue?vue&type=style&index=0&id=0a658149&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a658149",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a658149')) {
      api.createRecord('0a658149', component.options)
    } else {
      api.reload('0a658149', component.options)
    }
    module.hot.accept("./platformWithdrawal.vue?vue&type=template&id=0a658149&scoped=true", function () {
      api.rerender('0a658149', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/financeManagement/platformWithdrawal/platformWithdrawal.vue"
export default component.exports